import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';
import { extractRecords } from '../utils/responseHandlers';
import RefreshButton from "./RefreshButton";
import "./FiiDiiData.css";
import "./BulkDealsPage.css"; // Ensure intraday styles are available if not global

const FiiDiiData = ({ onBack }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("daily");

  const currentYearMonth = new Date().toISOString().slice(0, 7); // "YYYY-MM"

  const fetchData = async (type) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/fii-dii-data?request_type=${type}&year_month=${currentYearMonth}`
      );
      const result = await response.json();

      console.log("🚀 Full API Response:", result);

      // Use response handler to extract data from multiple possible formats
      let fiiDiiArray = extractRecords(result);
      setData(fiiDiiArray);

      console.log("✅ Final Data for table:", fiiDiiArray);
    } catch (error) {
      console.error("❌ Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activeTab);
  }, [activeTab]);

  return (
    <div className="intraday-page">
      {/* Header */}
      <header className="intraday-header">
        <div className="intraday-header-container">
          <div className="logo">
            <img src="images/Final Font Stocks4U1.png" className="logo-text" alt="Stocks4U" />
          </div>
          <div className="intraday-user">
            <RefreshButton
              onRefresh={() => fetchData(activeTab)}
              isLoading={loading}
              size="small"
              style={{ marginRight: '10px' }}
            />
          </div>
        </div>
      </header>

      {/* Page Content */}
      <main className="intraday-main">
        <div className="intraday-top">
          <div className="s4u-title-row">
            <div className="s4u-page-heading intraday-heading-override">
              <h1 className="page-title intraday-glowing-title">
                FII / DII Data <span className="info-icon">ℹ️</span>
              </h1>
              <button className="s4u-back-btn intraday-back-btn" onClick={onBack}>← Back to Dashboard</button>
            </div>
          </div>

          {/* Tabs */}
          <div className="categories">
            {["daily", "weekly", "monthly"].map((tab) => (
              <button
                key={tab}
                className={activeTab === tab ? "active" : ""}
                onClick={() => setActiveTab(tab)}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {/* Table Section */}
        <div className="intraday-table-container">
          <div className="high-turnover-table">
            {loading ? (
              <div className="loading">⏳ Loading data...</div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>FII Net (₹ Cr)</th>
                    <th>DII Net (₹ Cr)</th>
                    <th>Net Position (₹ Cr)</th>
                  </tr>
                </thead>
<tbody>
  {Array.isArray(data) && data.length > 0 ? (
    data.map((row, idx) => {
      const fii = Number(row.fii_net_value) || 0;
      const dii = Number(row.dii_net_value) || 0;
      const net = fii + dii;

      return (
        <tr key={idx}>
          {/* Date */}
          <td>
            {row.created_at
              ? new Date(row.created_at).toLocaleDateString("en-GB")
              : "N/A"}
          </td>

          {/* FII Net */}
          <td className={fii >= 0 ? "positive" : "negative"} style={{ textAlign: 'center' }}>
            {fii.toFixed(2)}
          </td>

          {/* DII Net */}
          <td className={dii >= 0 ? "positive" : "negative"} style={{ textAlign: 'center' }}>
            {dii.toFixed(2)}
          </td>

          {/* Net Position */}
          <td className={net >= 0 ? "positive" : "negative"} style={{ textAlign: 'center' }}>
            {net.toFixed(2)}
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="4" style={{ textAlign: "center" }}>
        No data available
      </td>
    </tr>
  )}
              </tbody>
            </table>
          )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default FiiDiiData;
